import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { HttpClient, HttpResponse } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})

export class ContactRelationService {

    constructor
    (
        private http: HttpClient
    ) {
    }

    getContactRelation(accountId, contactId) {
        return this.http.get<any>(`${environment.apiUrlAccount}v2/AccountContactParentChildRelation/ParentAccount/${accountId}/ParentContact/${contactId}`);
    }

    saveContactRelation(relationshipData) {
        return this.http.post<any>(`${environment.apiUrlAccount}v2/AccountContactParentChildRelation`, relationshipData)
    }

    makeAccountPrimaryContact(accountId: number,contactId: number) {
        return this.http.put<any>(`${environment.apiUrlAccount}Contact/MakePrimary/Account/${accountId}/Contact/${contactId}`,{})
    }
}
